import { strategyToolKeySchema } from '@ads/shared';
import { Navigate, useParams } from 'react-router';
import { Bmc } from './Bmc';
import { Diferenciais } from './Diferenciais';
import { Gaps } from './Gaps';
import { Horizontes } from './Horizontes';
import { Inovacao } from './Inovacao';
import { Macro } from './Macro';
import { PlanoAcao } from './PlanoAcao';
import { Triade } from './Triade';
import { Valores } from './Valores';
import { Visao } from './Visao';

/* Cada uma das dez ferramentas do Strategy tem a sua bancada. */
const VIEWS = {
  gaps: Gaps, diferenciais: Diferenciais, triade: Triade, visao: Visao, valores: Valores,
  bmc: Bmc, inovacao: Inovacao, macro: Macro, horizontes: Horizontes, w5h2: PlanoAcao,
} as const;

export function ToolRoute() {
  const { tool } = useParams();
  const parsed = strategyToolKeySchema.safeParse(tool);
  if (!parsed.success) return <Navigate to="/strategy" replace />;
  const View = VIEWS[parsed.data];
  return <View key={parsed.data} />;
}
